// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"66d2361a","217":"3d1b07fd","453":"5fe83a51","455":"1daabf88","631":"0c07c246","813":"14bbfc75","835":"659d7c4e","931":"8ebca4dd","935":"9b3da950","977":"3c7f9716","984":"814edfff","991":"159510a4"}[chunkId] + ".chunk.js";
};